import { reactive } from 'vue'

export function useProductCategoryDialog () {
  const state = reactive({
    isOpen: false,
    title: '',
    useSerialNumber: false,
    description: null,
    editId: null
  })

  const open = (config) => {
    const { title, useSerialNumber, description, editId } = config || {}
    state.title = title
    state.useSerialNumber = useSerialNumber
    state.description = description || null
    state.editId = editId
    state.isOpen = true
  }

  const close = () => {
    state.title = ''
    state.useSerialNumber = false
    state.description = null
    state.editId = null
    state.isOpen = false
  }

  return {
    state,
    open,
    close
  }
}
